import { render, staticRenderFns } from "./TravelPlanEditor.vue?vue&type=template&id=92945c24"
import script from "./TravelPlanEditor.vue?vue&type=script&lang=js"
export * from "./TravelPlanEditor.vue?vue&type=script&lang=js"
import style0 from "./TravelPlanEditor.vue?vue&type=style&index=0&id=92945c24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports